export const productMatchesTags = (productTags: string[], tags: string[]) => {
  return productTags.some((tag) => tags.includes(tag.toLowerCase()));
};

export function itemInInvalidCollection(
  itemCollections: string[],
  invalidCollections: string[],
): boolean {
  return itemCollections.some((collection) =>
    invalidCollections.includes(collection),
  );
}

export function listsHaveMatchingElement(list1: string[], list2: string[]) {
  return list1.some((key) =>
    list2.some((attribute) => attribute.toLowerCase() === key.toLowerCase()),
  );
}

export function itemValidForReturns({
  coverageExcludeProperties,
  coverageExcludeCollections,
  itemInfo,
  invalidProductTags,
}: {
  coverageExcludeProperties: string[];
  coverageExcludeCollections: string[];
  itemInfo: {
    properties: string[];
    productTags: string[];
    collections: string[];
  };
  invalidProductTags: string[];
}): boolean {
  let hasValidReturnProduct = false;
  const hasInvalidCollection = listsHaveMatchingElement(
    itemInfo.collections,
    coverageExcludeCollections,
  );
  const hasInvalidProperties = listsHaveMatchingElement(
    itemInfo.properties,
    coverageExcludeProperties,
  );
  const hasInvalidTags = listsHaveMatchingElement(
    itemInfo.productTags,
    invalidProductTags,
  );

  if (!hasInvalidTags && !hasInvalidCollection && !hasInvalidProperties) {
    hasValidReturnProduct = true;
  }
  return hasValidReturnProduct;
}

export function itemValidForProtection({
  itemInfo,
  invalidProductTags,
}: {
  itemInfo: {
    productTags: string[];
    // If you need to exclude package protection on collections or properties, you should make these parameters required
    collections?: string[];
    properties?: string[];
  };
  invalidProductTags: string[];
}): boolean {
  const hasInvalidTags = listsHaveMatchingElement(
    itemInfo.productTags,
    invalidProductTags,
  );

  return !hasInvalidTags;
}

export function itemValidForFinalSaleReturns({
  itemInfo,
  validProductTags,
  validCollections,
}: {
  itemInfo: { productTags: string[]; collections: string[] };
  validProductTags: string[];
  validCollections: string[];
}): boolean {
  const hasValidTags = listsHaveMatchingElement(
    itemInfo.productTags,
    validProductTags,
  );

  const hasValidCollections = listsHaveMatchingElement(
    itemInfo.collections,
    validCollections,
  );

  return hasValidTags || hasValidCollections;
}
